//TODO: remove unnecessary imports
import { lazy } from "react";
import { appPath, APP_PATHS } from '../utils/appPaths.js';
//import Crypto from "../Components/Dashboard/Crypto";

// //Application

// const SamplePage = React.lazy(() => import("../Components/Pages/Sample"));

import Default from "../Components/Dashboard/Default";
//import Ecommerce from "../Components/Dashboard/Ecommerce";
//import OnlineCourse from "../Components/Dashboard/OnlineCourse";
//import Social from "../Components/Dashboard/Social";

// //widgets
import Chart from "../Components/Widgets/Chart";
import General from "../Components/Widgets/General";
// //page-layout
// import FooterLight from '../Components/PageLayout/FooterLight';

// import FooterDark from '../Components/PageLayout/FooterDark';

// // Icons
import WeatherIcon from "../Components/Icons/WeatherIcon";
import FeatherIcon from "../Components/Icons/FeatherIcon";
import ThemifyIcon from "../Components/Icons/ThemifyIcon";
import IcoIcon from "../Components/Icons/IcoIcon";
import FontawesomeIcon from "../Components/Icons/FontawesomeIcon";
import FlagIcon from "../Components/Icons/FlagIcon";


// //Application
//import Newproject from "../Components/Application/Project/Newproject";
//import Project from "../Components/Application/Project/Project";
//* Users
import UsersContainer from "../Components/Application/Users";

//* Artist
import ArtistsContainer from "../Components/Application/Artists";

//* Labels
import LabelsContainer from "../Components/Application/Labels";

//* Products
import ProductsContainer from "../Components/Application/Products";
import AssetContainer from "../Components/Application/Products/Assets";

//* Contributors

import Contributors from "../Components/Application/Contributors";
import ContributorDetails from "../Components/Application/Contributors/Details";
import BudgetTrackContainer from "../Components/Application/BudgetTrack/BudgetTrackContainer";
import GeneralLedgerPage from "../Components/Application/GeneralLedger";
import ExpenseManagerPage from "../Components/Application/ExpenseManager";

//* Providers

//* Expenses
import MainExpenses from "../Components/Application/Expenses/Main-Expenses";
import ContributorExpenses from "../Components/Application/Expenses/Contrib-Expenses";

//* Invoices
import InvoicesTable from "../Components/Application/Invoices/InvoicesTable";
import NewInvoice from "../Components/Application/Invoices/NewInvoice";

// //Pages
import SamplePage from "../Components/Pages/Sample";
// // import SearchPage from '../Components/Application/SearchResult'

// //Profile app
import UsersEditContain from "../Components/Application/Profile/UsersEdit";

// //Income
import IncomesContainer from "../Components/Application/Income";
import NewIncome from "../Components/Application/Income/NewIncome";
import IncomeReport from "../Components/Application/Income/IncomeReport";
import YoutubeIncomeDetails from "../Components/Application/Income/YoutubeIncomeDetails";



import ContributorContainer from "../Components/Application/Contributors";
import ContributorsContainer from "../Components/Application/Products/Contributors";


//Exchange
import Exchange from "../Components/Application/Exchange";

// Settings
import ReportingSettings from "../Components/Application/Settings/ReportingSettings";

// Validation
import ValidationPage from "../Components/Application/Validation";

// AFR (Artist For Review)
import AfrPage from "../Components/Application/Afr";

// Catalog sync issues (ISRC/UPC conflicts — no GEN/ACC invent)
import CatalogSyncIssuesPage from "../Components/Application/CatalogSyncIssues";


export const routes = [
  // // Dashboard
  {
    path: appPath('/dashboard'),
    Component: <Default />,
    roles: ["admin","staff"],
  },

  ////Users
  {
    path: appPath('/users/users-list'),
    Component: <UsersContainer />,
    roles: ["admin", "staff"],
  },

   ////Artists
    {
      path: appPath('/artists/artists-list'),
      Component: <ArtistsContainer />,
      roles: ["admin", "staff"],
    },

    ////Labels
    {
      path: appPath('/labels/labels-list'),
      Component: <LabelsContainer />,
      roles: ["admin", "staff"],
    },

    ////Products

    {
      path: appPath('/products/products-list'),
      Component: <ProductsContainer />,
      roles: ["admin", "staff"],
    },

    {
      path: appPath('/products/:id/assets'),
      Component: <AssetContainer />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/contributors'),
      Component: <Contributors/>,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/contributors/:id'),
      Component: <ContributorDetails />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/products/:id/assets/:assetId/contributors'),
      Component: <ContributorsContainer />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/income/income-list'),
      Component: <IncomesContainer />,
      roles: ["admin", "staff"],
    },


    ////Invoices
    {
      path: appPath('/invoices/invoices-list'),
      Component: <InvoicesTable />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/invoices/invoices-new'),
      Component: <NewInvoice />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/income/income-new'),
      Component: <NewIncome />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/income/report/:id'),
      Component: <IncomeReport />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/income/youtube/:type/:id'),
      Component: <YoutubeIncomeDetails />,
      roles: ["admin", "staff"],
    },


    ////Providers

    ////Expenses
    {
      path: appPath('/expenses/red-expenses'),
      Component: <MainExpenses />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/expenses/contributors-expenses'),
      Component: <ContributorExpenses />,
      roles: ["admin", "staff"],
    },
    // Short paths (bookmark / external links often use /expenses)
    {
      path: appPath('/expenses'),
      Component: <ContributorExpenses />,
      roles: ["admin", "staff"],
    },
    {
      path: appPath('/expenses/inhouse'),
      Component: <MainExpenses />,
      roles: ["admin", "staff"],
    },

  {
    path: appPath('/widgets/general/:layout'),
    Component: <General />,
  },
  {
    path: appPath('/widgets/chart/:layout'),
    Component: <Chart />,
  },

    //Exchange
  {
    path: appPath('/exchange'),
    Component: <Exchange />,
  },

  {
    path: appPath('/settings/reporting'),
    Component: <ReportingSettings />,
    roles: ["admin"],
  },

  {
    path: appPath('/validation'),
    Component: <ValidationPage />,
    roles: ["admin"],
  },

  {
    path: appPath('/afr'),
    Component: <AfrPage />,
    roles: ["admin"],
  },

  {
    path: appPath('/catalog-sync-issues'),
    Component: <CatalogSyncIssuesPage />,
    roles: ["admin"],
  },

  {
    path: appPath('/budget-track'),
    Component: <BudgetTrackContainer />,
    roles: ["admin"],
  },

  {
    path: appPath('/general-ledger'),
    Component: <GeneralLedgerPage />,
    roles: ["admin", "staff"],
  },

  {
    path: appPath('/expenses-manager'),
    Component: <ExpenseManagerPage />,
    roles: ["admin", "staff"],
  },




  {
    path: appPath('/icons/flag_icons/:layout'),
    Component: <FlagIcon />,
  },
  {
    path: appPath('/icons/fontawesome_icon/:layout'),
    Component: <FontawesomeIcon />,
  },
  {
    path: appPath('/icons/ico_icon/:layout'),
    Component: <IcoIcon />,
  },
  {
    path: appPath('/icons/themify_icons/:layout'),
    Component: <ThemifyIcon />,
  },
  {
    path: appPath('/icons/feather_icons/:layout'),
    Component: <FeatherIcon />,
  },
  {
    path: appPath('/icons/weather_icons/:layout'),
    Component: <WeatherIcon />,
  },

  {
    path: appPath('/users/account/:layout'),
    Component: <UsersEditContain />,
  },

  // //page
  {
    path: appPath('/pages/sample-page/:layout'),
    Component: <SamplePage />,
  },

];
